import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

import c10v1a from './c10v1a';
import c41v1a from './c41v1a';

export default class c42v extends cView {

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stss = { // 親を上書き
  sdld_c10rListsss: {c10r:[]},
  sdld_c42rDtlsss: {c42r:[]},
  s_c10rc31s: '',
};

$id_stss = {
};

$clp_loadLists = () => [ // 親を上書き
  c10v1a.op_loadList({
    elm: 'c10r',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c10r', `c10rt11i = 20 AND c10rc11s <> "999999999999"`, false, false) // スタッフに限定
      return _cnd;
    },
  }),
];

static getC40rsAsync = (pd={
  c10r_key: null,
}) => new Promise( _o_end1 => {
  const _c10r_key = pd.c10r_key ?? global.t?.state.sgcd_cmnStgs.c10r_key;
  let _cnd = cf.c('c40r', `
    t_c40r._key IN (
      SELECT
        A.c410b41k
      FROM
        t_c410 AS A
      WHERE
        COALESCE(A.c410cz1i, 10) <> 0
        AND A.c410b21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
        AND A.c410b51k IN (
          SELECT
            B._key
          FROM
            t_c41r AS B
          WHERE
            COALESCE(B.c41rcz1i, 10) <> 0
            AND B.c41rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
            AND B._vsn = B._ltt
            AND B._fst IN (
              SELECT
                C.c420b51f
              FROM
                t_c420 AS C
              WHERE
                COALESCE(C.c420cz1i, 10) <> 0
                AND C.c420b21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                AND C._vsn = C._ltt
                AND C.c420b61k IN (
                  SELECT
                    D._key
                  FROM
                    t_c42r AS D
                  WHERE
                    COALESCE(D.c42rcz1i, 10) <> 0
                    AND D.c42rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                    AND D._vsn = D._ltt
                    AND D.c42rb11k = ${_c10r_key}
                )
            )
        )
    )
  `, true, false);
  cf.myCB_call_slc({
    elm: 'c40r',
    n_dms: 3,
    cnd: _cnd,
    ld_sortss: [
      {fld: 'c40rc11s', dtn: 'asc', mode: 'nmb'},
    ],
  })
  .then( _l => {
    _o_end1(_l);
  });
});

static op_loadDtl = (pd={
  elm: null,
  key: null,
  fst: null,
}) => 
  (pd.elm == 'c42r') ?
    super.op_loadDtl({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ??
          (pd.key) ?
            cf.c('c42r', `_key = ${pd.key}`) // 履歴対応 dd_cldDefss の cf.c も必ず b_ltt = false を設定 -> call_tree において強制適用？
          : (pd.fst) ?
            cf.c('c42r', `_fst = ${pd.fst}`) 
          : cf.c('c42r', `c42rb11k = ${global.t?.state.sgc_pageKey}`);
        return _cnd;
      }),
      d_insFlds: {
        c42rb21f: global.t?.state.sgcd_cmnStgs.c20r_fst,
        c42rb11k: global.t?.state.sgc_pageKey, // 新規登録時を考慮
      },
      dd_rfrss: {
        c10r: {
          elm: 'c10r',
          o_cnd: _d_flds => {
            let _cnd = cf.c('c10r', `_key = ${_d_flds.c42rb11k}`, false, false);
            return _cnd;
          },
        },
      },
      dd_cldDefss: {
        c420: {
          elm: 'c420',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('c420', `c420b61k = ${_dd_datss.c42r.d_flds._key ?? -1}`);
            return _cnd;
          },
        },
      },
      op_atrAll: () => new Promise( _o_end1 => {
        _o_end1();
      }),
    })
  : super.op_loadDtl(pd)
;

static op_loadVsnList = pd =>
  (pd.elm == 'c42r') ?
    super.op_loadVsnList({
      ...pd,      
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c(pd.elm, `c42rb11k = ${global.t?.state.sgc_pageKey}`)
        return _cnd;
      }),
    })
  : super.op_loadVsnList(pd)

$clp_loadDtls = () => [
  c42v.op_loadDtl({
    elm: 'c42r',
  }),
  c41v1a.op_loadSlcList({
    elm: 'c41r',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c41r', `c41rc11s <> "999999999999"`);
      return _cnd;
    },
  }),
  c42v.op_loadVsnList({ // 予約
    elm: `c42r`,
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c42rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      c42r: {
        elm: 'c42r',
        b_setPageKey: false,        
        od_insDats: pd => {
          let _d = {
//            c42rb11f: global.t?.state.sgc_pageFst ?? -1,
            c42rb11k: global.t?.state.sgc_pageKey ?? -1,
          };
          return _d;
        },
        dd_cldDefss: {
          c420: {
            elm: 'c420',
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                c420b61k: _dd_datss.c42r.d_flds._key ?? -1,
                c420b51f: _dd_datss.c420.d_flds.c420b51f ?? -1,
              };
              return _d;
            },
          },
        },
      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx: 
          (global.t?.state.sgc_pnlMode == 'list') ?
            'スタッフ権限一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            'スタッフ権限割当詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            'スタッフ権限割当変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            'スタッフ権限割当変更'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [
          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【スタッフ権限割当の確認・変更】･･･IDを押すと詳細画面に移動し、変更もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c10rListsss',
                    dd_elmDefss: {
                      c10r: {
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c10rc11s', {
                            b_edit: false,
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('c10rc31s', {
                            b_edit: false,
                            d_hdrs: { n_w: ic.s(16)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),
                      },
                    },
                  }),
                ])

              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'c42r',
                ld_iss: global.t?.state.sdld_c42rVsnListsss?.c42r,
                op_loadDtl: c42v.op_loadDtl,
              },
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -10,
                    state: 'sdld_c42rDtlsss',
                    dd_elmDefss: {
                      c42r: {
//                        b_row: true,
//                        b_ttl: false,
//                        b_rootHdr: true,
                        b_ttl: true,
                        b_row: false,
                        b_rootHdr: false,
/*
                        d_btns: {
                          d_clds: {
                            pfx: '役割を追加'
                          },
                        },
*/
                        d_cmns: {
                          n_cnt: 1,
                        },                        
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c10rc11s', {
                            pfx: 'スタッフID',
                            b_edit: false,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }), // 利用者ID
                          cf.f('c10rc31s', {
                            pfx: 'スタッフ名',
                            b_edit: false,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(16) },
                          }), // 利用者本名
                        ]),
                        dd_cldDefss: {
                          c420: {
                            elm: 'c420',
                            d_insFlds: cf.e('c420').d_insFlds, // 子要素の追加に必要
                          }
                        },
                      },
                    },
                  }),
                ]),

                ce.c(ce.Box, {
                  key: -20,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -20,
                    state: 'sdld_c42rDtlsss',
                    dd_elmDefss: {
                      c42r: {
                        elm: 'c42r',
                        dd_cldDefss: {
                          c420: {
                            b_row: true,
                            b_ttl: false,
                            b_subHdr: true,
                            b_lyr: false,
                            d_btns: {
                              d_btrs: {
                                pfx: '役割を追加'
                              },
                              d_dlts: {
                                pfx: ''
                              },
                            },
                            d_insFlds: cf.e('c420').d_insFlds,
                            dd_fldDefss: cf.myRN_getFldDefs([
                              cf.f('c420b51f', {
                                ld_iss: global.t?.state.sdld_c41rSlcListsss?.c41r,
                                d_hdrs: { n_w: ic.s(16)  },
                                d_bdys: { n_w: ic.s(16) },
                              }),
                            ]),
                            d_stlSubBdyCtas: {
                              borderWidth: 0,
                              borderTopWidth: ic.gn_bdrWNrw,
                              borderBottomWidth: ic.gn_bdrWNrw,
                              borderColor: ic.o_getCcd('d'),
                            },
                          },
                        },
                      },
                    },
                  }),
                ]),

              ],
            },
            d_btms: {
            },
          }),

        ],
      }
    })
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
